import PropTypes from 'prop-types';
import React, {Component} from 'react';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import {BillingHistory as BillingHistoryData} from '../AccountPageSectionsData';
import styles from '../AccountPageStyles';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import * as routes from 'App/routeConstants';
import CircularProgress from 'material-ui/CircularProgress';
import InlineButton from 'shared/components/InlineButton';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import {getInvoices} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {setInvoices} from 'MyAccount/ViewDesigns/redux/modules/accountPage';

@connectWithRouter(
  state => ({
    invoices: state.accountPage.invoices,
  }),
  {setInvoices}
)
export class BillingHistory extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {loading: true};
  }

  componentDidMount() {
    getInvoices().always(response => {
      if (response.success) {
        const {setInvoices} = this.props;
        setInvoices(response.invoices);
        this.setState({
          loading: false,
        });
      } else {
        // display error from response.message;
      }
    });
  }

  render() {
    const {loading} = this.state;
    const {invoices} = this.props;
    const loadingText = _.isEmpty(invoices) ? 'Loading Invoices...' : 'Updating Invoices...';
    return (
      <div style={styles.pageContentContainer}>
        <div style={styles.h1}>Billing History</div>
        <div style={{marginBottom: 30}}>
          Below are all the invoices for the charges effected by CrazyLister.
          <br />
          There is usually a delay of a few minutes before a payment shows up in the billing history.
          <br />
          Please don't hesitate to{' '}
          <InlineButton
            onClick={() => {
              window.Intercom('showNewMessage', 'Hello Crazylister\n' + 'I have a question about an invoice:');
            }}
          >
            contact us
          </InlineButton>{' '}
          if you have any queries about a charge.
        </div>
        {!_.isEmpty(invoices) && (
          <Table displaySelectAll={false} selectable={false} adjustForCheckbox={false}>
            <TableHeader
              style={{
                backgroundColor: Colors.grey200,
              }}
              displaySelectAll={false}
              adjustForCheckbox={false}
            >
              <TableRow
                style={{
                  height: 45,
                  textAlign: 'center',
                }}
              >
                <TableHeaderColumn style={{fontSize: 16}}>Date issued</TableHeaderColumn>
                <TableHeaderColumn style={{fontSize: 16}}>Invoice #</TableHeaderColumn>
                <TableHeaderColumn />
              </TableRow>
            </TableHeader>
            <TableBody showRowHover displayRowCheckbox={false}>
              {_.map(_.reverse(_.values(invoices)), invoice => {
                return (
                  <TableRow
                    style={{
                      fontSize: 16,
                      height: 35,
                    }}
                  >
                    <TableRowColumn style={{fontSize: 16}}>
                      {new Date(1000 * parseInt(_.get(invoice, 'date'), 10)).toLocaleDateString()}
                    </TableRowColumn>
                    <TableRowColumn style={{fontSize: 16}}>{_.get(invoice, 'invoiceNumber')}</TableRowColumn>
                    <TableRowColumn style={{fontSize: 16, textAlign: 'right'}}>
                      <InlineButton href={_.get(invoice, 'link')} target="_blank">
                        View Invoice
                      </InlineButton>
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
        {loading && (
          <div style={{display: 'flex', alignItems: 'center', marginBottom: 30}}>
            <CircularProgress color={Colors.lightGreen700} size={24} thickness={1.4} style={{margin: 13}} />
            <div color={Colors.grey700}>{loadingText}</div>
          </div>
        )}{' '}
        {!loading && _.isEmpty(invoices) && (
          <div>
            <b>No payments have been made.</b> Your invoices will appear here once you{' '}
            <InlineButton onClick={() => this.context.router.push(`${routes.MyAccount.Upgrade}`)}>upgrade</InlineButton>
            .
          </div>
        )}
      </div>
    );
  }
}

export default _.assign(BillingHistory, BillingHistoryData);
